import { React, useState, useEffect } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import PDFViewerView from "./PDFViewerView";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function PDFViewerMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "PDF Viewer & PDF Reader" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/pdf_viewer", title: "PDF Viewer" },
    data2: { link: "/pdf_viewer", title: "PDF Reader" },
    data3: { link: "/pdf_viewer", title: "Open PDF Documents Online" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="View PDF online instantly. Open, read, and navigate PDF documents quickly with our fast, secure, and user-friendly PDF viewer tool."
      ></meta>
      <meta
        name="keywords"
        content="pdf viewer, view pdf online, open pdf online, read pdf online, online pdf reader, pdf reader tool, pdf document viewer, fast pdf viewer, secure pdf viewer, pdf navigation tool, online pdf tool, pdf viewer free, pdf file reader, pdf document reader, pdf editor online"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <PDFViewerView
          title={title}
          onClose={() => {
            //set flags
            setSelectedFiles([]);
            setShowEditFileScreen(false);
            setStartProcessingFiles(false);
          }}
          file={selectedFiles.length > 0 ? selectedFiles[0] : null}
        ></PDFViewerView>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our PDF Reader website offers a fast, lightweight, and secure solution for viewing PDF files without requiring an internet connection. Built to work fully offline, this powerful tool allows users to open, read, and navigate PDF documents directly on their device, ensuring complete privacy and data protection. Whether you are reading eBooks, manuals, reports, invoices, or academic documents, this offline-ready PDF reader delivers smooth performance with clear text rendering and accurate page layout. The website also supports optional online access, giving users the flexibility to use it as a PDF viewer online or a fully offline application depending on their needs. With intuitive navigation, zoom controls, search functionality, and page thumbnails, users can easily read and manage documents using a reliable PDF reader online or offline. Optimized for speed and compatibility, the platform opens large PDF files quickly while preserving fonts, images, and formatting. Ideal for students, professionals, and everyday users, this website provides a secure and user-friendly way to read PDFs anytime, anywhere. If you are looking for a dependable PDF reader online, a lightweight PDF viewer online, or a privacy-focused offline PDF reading solution, this platform offers an seamless document viewing experience." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Open",
              step4: "View",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="PDF Reader"
            why_use={[
              {
                title: "Open and Read PDF Files Easily",
                description:
                  "Our PDF reader allows users to open and read PDF documents smoothly without layout or formatting issues.",
              },
              {
                title: "Access Documents Offline Anytime",
                description:
                  "This offline PDF reader lets you view important PDF files without internet access, ideal for work, study, and travel.",
              },
              {
                title: "Universal Document Compatibility",
                description:
                  "Our reliable PDF reader online ensures PDFs display consistently across different devices and operating systems.",
              },
              {
                title: "Fast and Lightweight Performance",
                description:
                  "Modern PDF reader tools open large PDF files quickly while maintaining clear text and high image quality.",
              },
              {
                title: "Perfect for Students and Professionals",
                description:
                  "Students and professionals rely on PDF viewer online and offline tools to read books, notes, reports, and contracts.",
              },
              {
                title: "Secure Viewing of Sensitive Files",
                description:
                  "Using an offline PDF reader keeps confidential documents secure by avoiding online uploads.",
              },
              {
                title: "Easy Search and Navigation",
                description:
                  "Our PDF reader online provides search, zoom, bookmarks, and page navigation for a better reading experience.",
              },
              {
                title: "Preserve Original Formatting",
                description:
                  "This quality PDF reader maintains original fonts, layouts, and images exactly as designed in the document.",
              },
              {
                title: "Read PDFs Anytime, Anywhere",
                description:
                  "With an offline PDF reader, users can access and read PDF documents anytime without internet dependency.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "What is a PDF viewer?",
                description:
                  "A PDF viewer is a tool that lets you open, read, and navigate PDF documents on your device. Depending on its features, it may also support zooming, page navigation, text search, rotation, and full-screen viewing.",
              },
              {
                title: "How can I view a PDF online for free?",
                description:
                  "Open the PDF Viewer on ShivaPDF.com, select a PDF file using the available file picker, and view the document in your browser. Check the tool's current features and usage limits for details about free access.",
              },
              {
                title: "Can I open a PDF without installing software?",
                description:
                  "Yes, a browser-based PDF viewer can let you open and read documents without installing a separate desktop application. You need a compatible browser and a device that supports the viewer.",
              },
              {
                title: "Can I view PDF files offline?",
                description:
                  "Offline PDF viewing is possible when the viewer and its required resources are available locally on your device. If ShivaPDF's viewer supports local processing, you may be able to open files after the page has loaded, even without an active internet connection.",
              },
              {
                title: "Does ShivaPDF PDF Viewer process files locally?",
                description:
                  "Local processing depends on how the viewer is implemented. If the PDF is rendered entirely in your browser, the document can be viewed on your device without being uploaded to a remote processing server. Check ShivaPDF's privacy information to confirm how files are handled.",
              },
              {
                title: "Is it safe to view PDF files online?",
                description:
                  "Safety and privacy depend on the viewer and how it handles documents. For sensitive files, use a trusted tool, review its privacy policy, and verify whether the document is uploaded or processed locally on your device.",
              },
              {
                title: "Can I view a PDF without uploading it?",
                description:
                  "Some browser-based PDF viewers can open and render files locally without uploading them. This depends on the tool's implementation. If ShivaPDF processes PDFs entirely in your browser, you can view supported files without sending their contents to a processing server.",
              },
              {
                title: "Can I use a PDF viewer for free?",
                description:
                  "A free PDF viewer lets you read PDF documents without purchasing dedicated viewing software. Check ShivaPDF's current tool page for its availability, supported features, and any usage restrictions.",
              },
              {
                title: "Can I view PDF files on Windows and Mac?",
                description:
                  "A web-based PDF viewer can work on Windows and macOS through a supported browser. Open the viewer, select your document, and use the available controls to read and navigate the PDF.",
              },
              {
                title: "Can I open a PDF on an iPhone or Android phone?",
                description:
                  "You may be able to open PDF files through a mobile browser using an online PDF viewer. The experience depends on the website's mobile layout, browser compatibility, and your device's available memory.",
              },
              {
                title: "Can I zoom in and out of a PDF?",
                description:
                  "Many PDF viewers include zoom controls that let you enlarge text, inspect images, or fit a page to the screen. Available zoom options depend on the viewer's features.",
              },
              {
                title: "Can I view individual pages in a PDF?",
                description:
                  "A PDF viewer generally lets you navigate between pages using page controls or scrolling. Some viewers also provide page thumbnails to help you jump quickly to a particular page.",
              },
              {
                title: "Can I search for text inside a PDF?",
                description:
                  "A PDF viewer with text-search support lets you find words or phrases in a document. Search works best when the PDF contains selectable text; scanned documents may require OCR before their text can be searched.",
              },
              {
                title: "Can I view scanned PDF documents?",
                description:
                  "Yes, a PDF viewer can display scanned documents when the pages are stored as images inside the PDF. However, searching for or selecting the text in scanned pages generally requires optical character recognition (OCR).",
              },
              {
                title: "Can I rotate PDF pages while viewing them?",
                description:
                  "Some PDF viewers provide page-rotation controls to make sideways or upside-down pages easier to read. Whether rotation changes only the current view or saves a permanent change depends on the tool.",
              },
              {
                title: "Can I view password-protected PDF files?",
                description:
                  "Password-protected PDFs may require the correct password before their contents can be displayed. Support depends on the viewer and the document's encryption settings.",
              },
              {
                title: "Can I view large PDF files in a browser?",
                description:
                  "Many browser-based PDF viewers can open large documents, but performance depends on file size, page count, image complexity, browser capabilities, and available memory. Very large PDFs may take longer to load.",
              },
              {
                title: "Can I view a PDF without downloading it?",
                description:
                  "A browser-based PDF viewer can display a selected document within the browser instead of requiring you to open a separate desktop application. If you already have a local PDF file, you may be able to view it directly without downloading another copy.",
              },
              {
                title: "Does a PDF viewer change my original file?",
                description:
                  "A viewer is generally designed to display a document rather than modify it. Simply viewing a PDF should not change its original contents, although tools that include editing or saving features may offer additional operations.",
              },
              {
                title: "Can I use a PDF viewer without creating an account?",
                description:
                  "Some online PDF viewers allow document viewing without account registration. Check ShivaPDF's current viewer page to confirm whether signing in or creating an account is required.",
              },
              {
                title: "Why is my PDF not opening in the viewer?",
                description:
                  "A PDF may fail to open because the file is damaged, incomplete, password-protected, unusually large, or incompatible with the viewer. Try opening another PDF, checking the file, or using an updated supported browser.",
              },
              {
                title: "Why does my PDF look different on different devices?",
                description:
                  "PDF appearance can vary slightly depending on screen size, zoom level, font availability, browser rendering, and device settings. Use the viewer's zoom and page-fit controls to improve readability.",
              },
              {
                title: "Can I use ShivaPDF PDF Viewer without an internet connection?",
                description:
                  "Offline use depends on whether the viewer's application code and required resources are already available on your device. A typical website needs an internet connection to load initially, while a locally available viewer may continue to work offline if designed to support it.",
              },
              {
                title: "Why should I use ShivaPDF PDF Viewer?",
                description:
                  "A browser-based PDF viewer provides a convenient way to read documents without installing a separate application. Visit ShivaPDF's tool page to check the available viewing controls, device compatibility, privacy details, and offline support.",
              },
            ]} />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext>
  );
}

export default PDFViewerMain;
